<template>
<div style="margin-right:20px;">
    <button class="btn btn-default btn-sm" style="height: 40px;" @click="send()">{{ label }}</button>
</div>
</template>

<script>
export default {
    props: {
        customerId: {
            required: true
        },
        action: {
            required: true
        },
        label: {
            required: true
        },
        confirmText: {
            required: true
        },
        successMessage: {
            required: true
        },
        channel: {
            required: false,
            default: 'email'
        }
    },
    methods: {
        send () {
            const self = this

            if (!confirm(self.confirmText)) {
                return
            }

            self.$http.post('/customers/' + self.customerId + '/' + self.action, { channel: self.channel }).then(() => {
                bus.$emit('notify', self.successMessage)
                bus.$emit('log-reload')
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        }
    }
}
</script>
